import React, { useEffect, useState } from 'react';
import { _$, _addClass, _setText } from '../../../../controllers/dom'; // , , _removeClass, _setText
import { NotificationManager } from 'react-notifications';
import { locales } from '../../../../translations/locales';
import BtnStatus from '../status/BtnStatus';

const ManageCarsBuilding = (props) => {
    const { theme, locale, ModuleRP, data, setActivePage } = props;
    const [addVehicle, setAddVehicle] = useState(false);
    const [waitForUpdate, setWaitForUpdate] = useState(false);

    const addVehicleInBuilding = () => {
        if (!_$('vehicleName').value) {
            _addClass('vehicleName', ['border', 'border-danger']);
            return NotificationManager.error(locales[locale].notifications.newGameNameInvalid);
        }
        ModuleRP.config.addVehicleInBuilding(data.building.id, { name: _$('vehicleName').value, modelId: _$('vehicleType').value });
        setWaitForUpdate(true);
    };

    const manageVehicle = (vehicleId) => {
        const vehicle = data.building.vehicles.find((vehicle) => vehicle.id === vehicleId);
        ModuleRP.config.manageVehicleInBuilding(vehicle);
        setActivePage('EditVehicleInBuilding');
    };

    useEffect(() => {
        if (waitForUpdate && _$('btn-addVehicleInBuilding')) {
            _setText('btn-addVehicleInBuilding', locales[locale].config.add);
            _$('btn-addVehicleInBuilding').disabled = false;
            setWaitForUpdate(false);
        }
        ModuleRP.config.manageVehicleInBuilding(null);
        setAddVehicle(false);
    }, [data]);

    return (
        <div>
            <div id='listVehicleInBuilding'>
                <hr className={`m - 4 bg - secondary`} />
                <h5 className="card-title">{locales[locale].config.manageCars}</h5>
                <table className={`table table - hover table - ${theme === 'DARK' ? 'dark' : 'light'} `}>
                    <thead>
                        <tr>
                            <th>{locales[locale].gamesTable.gameNames}</th>
                            <th>{locales[locale].gamesTable.vehicleType}</th>
                            <th>{locales[locale].gamesTable.functions}</th>
                            <th>{locales[locale].gamesTable.vehicleStatus}</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            data.building.vehicles && data.building.vehicles.map((vehicle) =>
                            (<tr key={vehicle.id} id={vehicle.id}>
                                <td>{vehicle.name}</td>
                                <td>
                                    {data.vehicleModels && data.vehicleModels.find(
                                        (vehicleModel) => vehicleModel.id === vehicle.modelId && vehicleModel.type === 'vehicleModel')?.name
                                    }
                                </td>
                                <td>
                                    {data.vehicleModels && data.vehicleModels.find(
                                        (vehicleModel) => vehicleModel.id === vehicle.modelId)?.functions.map((functionObject) => (
                                            <span key={vehicle.id + functionObject.id} className='badge badge-primary p-1 m-1'>
                                                {functionObject.name}
                                            </span>
                                        ))}
                                </td>
                                <td>
                                    <BtnStatus listStatus={data.listStatus} code={vehicle.status} />
                                </td>
                                <td>
                                    <button
                                        className='btn btn-sm btn-primary float-right'
                                        id='btn-manageVehicle'
                                        onClick={() => {
                                            manageVehicle(vehicle.id);
                                        }}
                                    >
                                        {locales[locale].config.manage}
                                    </button>
                                </td>
                            </tr>
                            ))
                        }
                        {
                            data.building.vehicles && data.building.vehicles.length === 0 ?
                                <tr>
                                    <td colSpan={2}>
                                        {locales[locale].config.noVehicles}
                                    </td>
                                </tr> :
                                <tr></tr>
                        }
                        <tr>
                            <td colSpan={5}>
                                <button
                                    className='btn btn-sm btn-primary'
                                    id='btn-addVehicle'
                                    onClick={() => setAddVehicle(true)}
                                >{locales[locale].config.addNewVehicle}</button>
                                <div className={addVehicle ? '' : 'hide'} id="addVehicle">
                                    <hr className={`m - 4 bg - secondary`} />
                                    <h5 className="card-title">{locales[locale].config.addNewVehicle}</h5>
                                    <div className="row">
                                        <div className="col-sm-6">
                                            <h6>{locales[locale].gamesTable.vehicleName}</h6>
                                            <form onSubmit={(event) => {
                                                event.preventDefault();
                                                addVehicleInBuilding();
                                            }}>
                                                <input
                                                    type='text'
                                                    className='form-control'
                                                    id='vehicleName'
                                                    placeholder={locales[locale].config.vehicleName}
                                                    maxLength={35}
                                                />
                                            </form>
                                        </div>
                                        <div className="col-sm-4">
                                            <h6>{locales[locale].gamesTable.vehicleType}</h6>
                                            <form onSubmit={(event) => {
                                                event.preventDefault();
                                                addVehicleInBuilding();
                                            }}>
                                                <select
                                                    className='form-control'
                                                    id='vehicleType'
                                                >
                                                    {
                                                        data.vehicleModels && data.vehicleModels.map((vehicleModel) => (
                                                            <option key={vehicleModel.id} value={vehicleModel.id}>
                                                                {vehicleModel.name}
                                                            </option>
                                                        ))
                                                    }
                                                </select>
                                            </form>
                                        </div>
                                        <div className="col-sm-2">
                                            <h6>-</h6>
                                            <button
                                                className='btn btn-sm btn-primary float-right'
                                                id='btn-addVehicleInBuilding'
                                                onClick={() => {
                                                    addVehicleInBuilding();
                                                }}
                                            >
                                                {locales[locale].config.add}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default ManageCarsBuilding;
